<template >
  <v-card
    class="ma-md-5 ma-lg-10"
  >
    <v-breadcrumbs v-if="crumbs.length > 1"
      :items="crumbs.map((el, $index) => ({ $index, ...el, }))"
    >
      <template v-slot:item="{ item }" >
        <v-breadcrumbs-item
          :to="item.to"
          :disabled="item.disabled"
          :exact=true
        >
          <v-icon
            color="primary"
            v-if="item.$index === 0"
          >{{ item.text }} </v-icon>
          <template v-else>{{ item.text }}</template>
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <Form
      v-if="!category && !loading"
      id="SearchBarCatalogIncident"
      ref="defaultFormDataSearchIncident"
      class="px-4"
      :data="{ properties: formFields }"
      :submitVisible="false"
    >
    </Form>

    <template v-if="loading">
      <template v-for="i in 5">
        <v-divider
          :key="`divider-${i}`"
        ></v-divider>

        <v-skeleton-loader
          :key="i"
          type="list-item-avatar"
          class="mx-auto my-4"
        ></v-skeleton-loader>
      </template>
    </template>

   <transition name="fade">
      <LinksList
        v-if="!loading && category"
        :preffix="'/element/i'"
        :items="elements[category.id].elements"
      >
        <template #item-actions="{ item }" v-if="!this.user.hasIosUser()">
          <v-list-item-action class="my-0">
            <v-btn width="48" height="48" icon @click.stop="$event => share($event, item)">
              <v-icon color="primary">mdi-share-variant</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action class="my-0">
            <v-btn width="48" height="48" icon @click.stop="$event => toggleFav($event, item)">
              <v-icon color="primary">
                  {{ isElementInBookmark(item)
                  ? 'mdi-bookmark' : 'mdi-bookmark-outline' }}
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </template>
      </LinksList>
    </transition>

     <ShareDialog
      :visible="openDialog"
      @input="openDialog = false"
      :item="sharedItem || {}"
      :positionX="sharedDialogPosition.positionX"
      :positionY="sharedDialogPosition.positionY"
    ></ShareDialog>

  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { STATUS } from '@/store/modules/catalog';
import { STATUS as BOOKMARKS_STATUS, BOOKMARK_TYPES } from '@/store/modules/bookmarks';
import { LinksList, Form, ShareDialog } from '@/components';
import FieldBuilderUtil from '@/components/form/field-builder-util';

const ticketTypeToBookmarkType = (type) => {
  switch (type) {
  default:
  case 'R': return BOOKMARK_TYPES.REQUESTS;
  case 'I': return BOOKMARK_TYPES.INCIDENTS;
  }
};

export default {
  props: {
    ticketType: String,
    bookmarks: Boolean,
    searchtext: String,
  },
  components: {
    LinksList,
    Form,
    ShareDialog,
  },
  created() {
    // const { catalogId, categoryId, elementId } = this;
    if (typeof (this.elements[this.category.id] || {}).elements === 'undefined' || (this.elements[this.category.id] || {}).elements === null) {
      this.$store.dispatch('catalog/loadCatalogIncidents', {
        userId: this.user.id,
        locationId: this.user.location.id,
        type: this.ticketType,
      });
    }
    const bookmarkType = ticketTypeToBookmarkType(this.ticketType);
    const bookmarkTypeStatus = this.$store.getters['bookmarks/status'](bookmarkType);
    // if bookmarks[type] are not loaded yet we will request them
    if (![BOOKMARKS_STATUS.SUCCESS, BOOKMARKS_STATUS.LOADING].includes(bookmarkTypeStatus)) {
      this.$store.dispatch('bookmarks/get', { type: bookmarkType });
    }
  },
  computed: {
    ...mapState({
      user: ({ session }) => session.session.user,
      loading: ({ catalog: { status } }) => status === STATUS.LOADING,
      loaded: ({ catalog: { status } }) => [STATUS.SUCCESS, STATUS.ERROR].includes(status),
      categories: ({ catalog }) => catalog.categories,
      listCatalogs: ({ catalog }) => Object.keys(catalog.categories.I).map(
        (key) => catalog.categories.I[key].model,
      ),
      elements: ({ catalog }) => catalog.categories.I,
      category({ catalog }) {
        const result = Object.keys(catalog.categories.I).map(
          (key) => catalog.categories.I[key].model,
        );
        return (result[0] || {});
      },
      formFields() {
        return [
          FieldBuilderUtil
            .createField('searchCatalog').ofType('search')
            .withSequence(5)
            .withLabel(this.$t('navbar.incidentSearch'))
            .withConfig({
              initialvalue: typeof this.searchtext === 'string' ? this.searchtext : undefined,
              component: 'catalogsearch',
              size: {
                sm: 6,
                md: 16,
                xl: 16,
                lg: 16,
              },
            })
            .withParams({
              mode: 'remote',
              target: 'namedquery',
              entity: 'catalogsByName',
              fields: 'id,name',
              'filters:repl': `${JSON.stringify({ type: 'I', text: '#value' })}`,
              lookandfeel: '#item.name',
            })
            .build(),
        ];
      },
      isElementInBookmark() {
        const type = ticketTypeToBookmarkType(this.ticketType);
        return (element) => this.$store.getters['bookmarks/isInBookmark'](type, element.id);
      },
    }),
    crumbs() {
      const routePath = this.$route.path.endsWith('/') ? this.$route.path.slice(0, -1) : this.$route.path;
      const pathArray = routePath.split('/');
      pathArray.shift();
      const pathRepo = [
        [{ id: pathArray[0], name: 'mdi-keyboard-backspace' }], // first breadcrumb element forced to be translated
        this.listCatalogs,
        this.elements[this.category]];
      const breadcrumbs = pathArray.reduce((breadcrumbArray, path, idx) => {
        breadcrumbArray.push({
          path,
          to: breadcrumbArray[idx - 1]
            ? `/${ breadcrumbArray[idx - 1].path }/${ path}`
            : `/${ path}`,
          text: ((pathRepo[idx] || []).find((el) => el.id === path) || {}).name || path,
        });
        return breadcrumbArray;
      }, []);
      return breadcrumbs;
    },
  },
  data: () => ({
    sharedItem: null,
    sharedDialogPosition: {},
    openDialog: false,
  }),

  methods: {
    cleanPath(path) {
      return path.endsWith('/') ? path.slice(0, -1) : path;
    },
    share(evt, item) {
      console.log('evt', evt);
      evt.preventDefault();
      const isMobile = this.$store.getters['globalState/get']('deviceOS') != null;
      if (isMobile === true && window.flutter_inappwebview) {
        const args = {
          name: `${this.$t(`components.share.subjectBody.${this.ticketType}`)} ${item.name}`,
          url: `${window.location.origin}${this.$router.options.base}element/i/${item.id}`,
          formName: item.name,
        };
        window.flutter_inappwebview.callHandler('shareDataUsingNative', args);
      } else {
        const fullShareUrl = `${process.env.VUE_APP_EXTERNAL_URL}${process.env.VUE_APP_BASE_URL_MICS_SSPA}element/i/${item.id}`;
        this.openDialog = true;
        this.sharedItem = {
          text: `${this.$t(`components.share.subjectBody.${this.ticketType}`)} ${item.name}`,
          url: fullShareUrl,
          formName: item.name,
        };

        const closestButton = evt.target.closest('button');
        const boundingRect = closestButton.getBoundingClientRect();

        this.sharedDialogPosition = {
          positionX: boundingRect.left + (closestButton.offsetWidth / 2),
          positionY: boundingRect.top + (closestButton.offsetHeight / 2),
        };
      }
    },
    async toggleFav(evt, item) {
      evt.preventDefault();

      const action = this.isElementInBookmark(item) ? 'bookmarks/remove' : 'bookmarks/add';
      try {
        await this.$store.dispatch(action, {
          type: ticketTypeToBookmarkType(this.ticketType),
          element: item,
        });
      } catch (ex) {
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.requestCreationView.bookmarksSyncError'),
          icon: 'mdi-times',
          type: 'error',
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
  },
};

</script>

<style lang="scss">
  .fade-enter-active {
    transition: opacity .2s;
  }
  .fade-enter {
    opacity: 0;
  }
  .fade-leave-active {
    display: none;
  }
</style>
